import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTA = () => {
  return (
    <section className="py-24 px-6 bg-gradient-to-br from-sage-600 to-sage-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl"></div>
      </div>
      
      <div className="relative max-w-4xl mx-auto text-center">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6">
          Siap Meningkatkan Kualitas<br />Acara Wisuda di Kampus Anda?
        </h2>
        
        <p className="text-xl text-sage-50 mb-10 max-w-2xl mx-auto leading-relaxed">
          Rasakan langsung bagaimana Wisuda.ai membantu menciptakan acara wisuda yang tertib, 
          informatif, dan berkesan.
        </p>
        
        <button className="group px-10 py-5 bg-white hover:bg-cream-50 text-sage-700 font-bold text-lg rounded-full transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1">
          <span className="flex items-center gap-3">
            Coba Demo Wisuda.ai
            <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform" />
          </span>
        </button>
      </div>
    </section>
  );
};

export default CTA;
